var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('reset-password-form',{attrs:{"type":'activate'},on:{"activated":function($event){return _vm.$router.replace('/login')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }